import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "ui-motion-control inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-accent text-accent-foreground hover:bg-accent-hover hover:ring-1 hover:ring-accent",
        secondary:
          "bg-surface-3 text-text-primary hover:bg-surface-4",
        ghost:
          "hover:bg-glass-bg-hover text-text-secondary hover:text-text-primary",
        glass:
          "bg-glass-bg border border-glass-border text-text-primary hover:bg-glass-bg-hover hover:border-glass-border-hover",
        glow: "bg-accent text-accent-foreground hover:bg-accent-hover hover:ring-1 hover:ring-accent",
        outline:
          "border border-glass-border bg-transparent text-text-primary hover:bg-glass-bg-hover hover:border-glass-border-hover",
        destructive:
          "bg-surface-4 text-text-secondary border border-glass-border hover:bg-accent-hover hover:text-accent-foreground hover:ring-1 hover:ring-accent",
        link: "text-accent underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 px-3",
        lg: "h-11 px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
